import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Stack({ className, ...rest }) {
    return _jsx("div", { className: cn("fwfa-stack", className), ...rest });
}
//# sourceMappingURL=Stack.js.map